export default [

	{
		title: 'Development Type',
		header: 'Is your development a \'Schedule 1\' development?',
		help: 'Development classified as \'Schedule 1\' development includes all large-scale development, such as power stations, oil refineries, major infrastructure hubs and infrastructure. EIA is compulsory for these projects.',
		help2: 'UK Government definitions: <a href="https://www.legislation.gov.uk/uksi/2017/571/schedule/1/made" target="_blank">https://www.legislation.gov.uk/uksi/2017/571/schedule/1/made</a>',
		component: () => import( /* webpackChunkName: "stages" */ '../components/stages/ScheduleOne' ),
	},

];
